export const EXTERNAL_LINK = 'main-header.external-link',
  MULTIPLE_EXTERNAL_LINK = 'main-header.multiple-external-link',
  PUCCPAGES_LINK = 'menu.pucc-page',
  MICROSITE_LINK = 'menu.pucc-microsite'
